module.exports = __webpack_public_path__ + "static/media/Pyukumuku_gaussian2.b8aa994a.png";